import { useGetSelectData } from 'generation/centerFrontedEngine'

export function TargetSync({ modelID, selectID }: { modelID: string; selectID: 'Target1' }) {
  const target = useGetSelectData({ modelID, selectID })
  return <>{target.name}</>
}
